export const REASON = {
    variant: "no variant selected",
    store: "no store selected",
    escape: "selected all, didn't continue",
    noStores: "no stores with availability",
};
